import { forwardRef, InputHTMLAttributes } from 'react';
import { FormCheckboxContainer, FormCheckboxInput, FormCheckboxLabel } from './Checkbox.style';

interface FormCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const FormCheckbox = forwardRef<HTMLInputElement, FormCheckboxProps>(({ label, ...props }, ref) => {
  return (
    <FormCheckboxContainer>
      <FormCheckboxInput type="checkbox" ref={ref} {...props} />
      <FormCheckboxLabel>{label}</FormCheckboxLabel>
    </FormCheckboxContainer>
  );
});

FormCheckbox.displayName = 'FormCheckbox';

export default FormCheckbox;
